import { render, staticRenderFns } from "./AmendFormEdit.vue?vue&type=template&id=215c2a94&"
import script from "./AmendFormEdit.vue?vue&type=script&lang=js&"
export * from "./AmendFormEdit.vue?vue&type=script&lang=js&"
import style0 from "./AmendFormEdit.vue?vue&type=style&index=0&id=215c2a94&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports